<mat-card>
  <div class="storage-form-container">
    <form *ngIf="storageForm" [formGroup]="storageForm" (submit)="submit()" autocomplete="off">
      <mat-card-header class="storage-form-header">
        <mat-card-title>
          <h2 mat-dialog-title>
            {{ data?.storage ? 'Edit Well Storage' : 'Create New Well Storage' }}
          </h2>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content class="grid grid-cols-2 gap-x-1">
        <div class="grid grid-cols-2 gap-1 w-full">
          <div class="flex flex-col form-field">
            <div class="form-field-label">
              Storage Unit Identifier
            </div>
            <mat-form-field appearance="outline" class="storage-form-field">
              <input
                matInput
                [formControl]="storageForm.controls['name']"
                saAutomatedSelector="well-creation-new-storage__storage-unit-identifier"
              />
              <mat-error *ngIf="storageForm.controls['name'].hasError('required')">
                Input is required
              </mat-error>
            </mat-form-field>
          </div>
          <div class="flex flex-col form-field">
            <div class="form-field-label">
              Storage Type
            </div>
            <mat-form-field appearance="outline" class="storage-form-field">
              <mat-select
                [formControl]="storageForm.controls['storageType']"
                [compareWith]="compareFn"
                saAutomatedSelector="well-creation-new-storage__storage-type"
              >
                <mat-option *ngFor="let storageType of storageTypes" [value]="storageType">
                  {{ storageType.name }}
                </mat-option>
              </mat-select>

              <mat-error *ngIf="storageForm.controls['storageType'].hasError('required')">
                Input is required
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="grid grid-cols-2 gap-1 w-full" *ngIf="isHalAccount">
          <div class="flex flex-col form-field">
            <div class="form-field-label">
              Material
            </div>
            <mat-form-field appearance="outline" class="storage-form-field">
              <mat-select
                [formControl]="storageForm.controls['material']"
                [compareWith]="materialCompareFn"
                saAutomatedSelector="well-creation-new-storage__material-type"
              >
                <mat-optgroup *ngFor="let group of materialNumbers" [label]="'Mesh ' + group[0]">
                  <mat-option *ngFor="let materialNumber of group[1]" [value]="materialNumber.materialNumber">{{
                    materialNumber.materialNumber
                  }}</mat-option>
                </mat-optgroup>
              </mat-select>
              <mat-error *ngIf="storageForm.controls['material'].hasError('required')">
                Input is required
              </mat-error>
            </mat-form-field>
          </div>
          <div class="flex flex-col form-field">
            <div class="form-field-label">
              Sales Order Line Item
            </div>
            <mat-form-field appearance="outline" class="storage-form-field">
              <input
                matInput
                type="text"
                autocomplete="off"
                [formControl]="storageForm.get('salesOrderLineItem')"
                saAutomatedSelector="well-creation-new-storage__salesOrderLineItem"
              />
              <mat-error *ngIf="storageForm.controls['salesOrderLineItem'].hasError('required')">
                Input is required
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="grid gap-1 w-full" *ngIf="isBox()">
          <div class="flex flex-col form-field">
            <div class="form-field-label">
              Box Technology
            </div>
            <mat-form-field
              *ngIf="storageForm.controls['storageType'].value?.id === 2"
              appearance="outline"
              class="storage-form-field"
            >
              <mat-select [formControl]="storageForm.controls['boxTechnology']" [compareWith]="compareFn">
                <mat-option *ngFor="let boxType of boxTechnologies$ | async" [value]="boxType">
                  {{ boxType.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="grid grid-cols-2 gap-1 w-full">
          <div class="flex flex-col form-field">
            <div class="form-field-label">
              Mesh Type
            </div>
            <mat-form-field appearance="outline" class="storage-form-field">
              <mat-select
                [formControl]="storageForm.controls['mesh']"
                [compareWith]="compareFn"
                saAutomatedSelector="well-creation-new-storage__mesh-type"
              >
                <mat-option *ngFor="let mesh of meshTypes" [value]="mesh">{{ mesh.type }} Mesh</mat-option>
              </mat-select>
              <mat-error *ngIf="storageForm.controls['mesh'].hasError('required')">
                Input is required
              </mat-error>
              <!-- <mat-hint *ngIf="storageForm.get('mesh').disabled">
                Please create a new storage if you would like to use a different mesh.
              </mat-hint> -->
            </mat-form-field>
          </div>
          <div class="flex flex-col form-field">
            <div class="form-field-label">
              {{ isBox() ? 'Room for ' + meshName + ' Mesh boxes' : 'Mesh Capacity (lbs)' }}
            </div>
            <mat-form-field appearance="outline" class="storage-form-field">
              <div *ngIf="isBox(); then roomForMeshBoxes; else meshCapacity"></div>
              <ng-template #roomForMeshBoxes>
                <input
                  matInput
                  sa-number-input
                  (input)="onMeshCapacityChange()"
                  type="text"
                  [formControl]="storageForm.controls['capacity']"
                  saAutomatedSelector="well-creation-new-storage__mesh-capacity"
                />
              </ng-template>
              <ng-template #meshCapacity>
                <input
                  matInput
                  sa-number-input
                  (input)="onMeshCapacityChange()"
                  type="text"
                  [formControl]="storageForm.controls['capacity']"
                  saAutomatedSelector="well-creation-new-storage__mesh-capacity"
                />
              </ng-template>
              <mat-error *ngIf="storageForm.controls['capacity'].hasError('required')">
                Input is required
              </mat-error>
              <mat-error
                *ngIf="
                  storageForm.controls['capacity'].hasError('min') &&
                  !storageForm.controls['capacity'].hasError('required')
                "
              >
                Value cannot be negative
              </mat-error>
              <mat-error
                *ngIf="
                  storageForm.controls['capacity'].hasError('max') &&
                  !storageForm.controls['capacity'].hasError('required')
                "
              >
                Value cannot be more than 100,000,000
              </mat-error>
              <!-- <mat-hint *ngIf="isBox()">
                How many {{ meshName }} Mesh Boxes do you have room to unload on location?
              </mat-hint> -->
            </mat-form-field>
          </div>
        </div>
        <div [ngClass]="isBox() ? 'grid grid-cols-2 gap-1 w-full' : 'grid gap-1 w-full'">
          <div class="flex flex-col form-field" *ngIf="isBox()">
            <div class="form-field-label">
              Boxes Per Load
            </div>
            <mat-form-field appearance="outline" class="storage-form-field">
              <mat-select formControlName="numberBoxes">
                <mat-option *ngFor="let boxSize of boxSizes" [value]="boxSize"> {{ boxSize }} Box </mat-option>
              </mat-select>

              <mat-error *ngIf="storageForm.controls['storageType'].hasError('required')">
                Input is required
              </mat-error>
            </mat-form-field>
          </div>
          <div class="flex flex-col form-field">
            <div class="form-field-label">
              Load Weight (lbs)
            </div>
            <mat-form-field appearance="outline" class="storage-form-field">
              <input
                matInput
                type="text"
                sa-number-input
                autocomplete="off"
                [formControl]="storageForm.get('loadWeight')"
                saAutomatedSelector="well-creation-new-storage__load-weight"
              />
              <mat-error *ngIf="storageForm.get('loadWeight').hasError('required')">
                Input is required
              </mat-error>
              <mat-error *ngIf="storageForm.get('loadWeight').hasError('min')">
                Value must be greater than 0
              </mat-error>
              <mat-error *ngIf="storageForm.get('loadWeight').hasError('max')">
                Value must be less than or equal to {{ maxWeight | number }}
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div matDialogActions fxLayout="row" fxLayoutAlign="flex-start" class="actions">
          <button
            *ngIf="canEdit"
            mat-flat-button
            color="primary"
            type="submit"
            [disabled]="submitting"
            saAutomatedSelector="well-creation-new-storage__submit-button"
          >
            {{ submitting ? 'Submitting...' : 'Submit' }}
          </button>
          <button
            mat-flat-button
            color="primary"
            mat-dialog-close
            color="accent"
            saAutomatedSelector="well-creation-new-storage__cancel-button"
          >
            Cancel
          </button>
        </div>
      </mat-card-content>
    </form>
  </div>
</mat-card>
